import React from 'react';
import {
    Redirect,
    Route,
} from "react-router-dom";
import isEmpty from 'lodash/isEmpty';

import { LOCAL_STORAGE_USER_DATA_NAME } from '../constants';

const PublicRoute = props => {
    const userData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA_NAME) || '{}');
    return !isEmpty(userData) ? <Redirect to="/products" /> : <Route component={props.component} exact={props.exact} path={props.path} />;
}

export default PublicRoute;